let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i8fRm")).then(() => parcelRequire('9heXR'));